// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__2oEb7","actionsCol":"EnrolledClinics_actionsCol__nJz_I"};